import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ViewComponent } from './view.component';
import {
  CurriculumJavaScriptComponent
} from '../components/sections/curriculum/curriculum-js-dev/curriculum-java-script.component';
import {
  CurriculumUxDesignComponent
} from '../components/sections/curriculum/curriculum-ux-design/curriculum-ux-design.component';
import { CurriculumJavaComponent } from '../components/sections/curriculum/curriculum-java/curriculum-java.component';

const routes: Routes = [
  {
    path: '',
    component: ViewComponent,
    children: [
      {
        path: '',
        component: CurriculumJavaScriptComponent
      },
      {
        path: 'ux-design',
        component: CurriculumUxDesignComponent
      },
      {
        path: 'javascript',
        component: CurriculumJavaScriptComponent
      },
      {
        path: 'angularjs',
        component: CurriculumJavaComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ViewRoutingModule {}
